module.exports = __webpack_public_path__ + "static/media/work-1.052ca3e0.png";